import a from "universal-cookie";
function n(r, e) {
  return typeof e == "object" && r in e ? e[r] : void 0;
}
class p extends a {
  namePrefix;
  initialSetOptions;
  cookieOptionOverrides;
  /**
   * @deprecated
   * Use `getItem` instead
   */
  get() {}
  /**
   * @deprecated
   * Use `setItem` instead
   */
  set() {}
  /**
   * @deprecated
   * Use `removeItem` instead
   */
  remove() {}
  constructor({
    cookies: e,
    namePrefix: t,
    cookieOptionOverrides: i,
    ...o
  } = {}) {
    super(e, o), this.namePrefix = t ?? "", this.initialSetOptions = o, this.cookieOptionOverrides = i;
  }
  getItem(e, t) {
    const i = this.namePrefix + e;
    return super.get(i, {
      ...t,
      doNotParse: !t?.parse
    });
  }
  setItem(e, t, i) {
    const o = this.namePrefix + e,
      s = n(e, this.cookieOptionOverrides),
      c = s ? {
        ...i,
        ...s
      } : i;
    super.set(o, t, c);
  }
  removeItem(e, t) {
    const i = this.namePrefix + e,
      o = n(e, this.cookieOptionOverrides),
      s = o ? {
        ...t,
        ...o
      } : t;
    super.remove(i, {
      ...this.initialSetOptions,
      ...s
    });
  }
}
export { p as CookieManager };